import { combineReducers } from 'redux';
import counterReducer from '../modules/test/reducers';
import superAdminReducer from '../modules/users/store/reducers';
import userReducer from '../userReducer';
import paymentsReducer from '../modules/payments/store/reducers/index';
import IMCReducer from '../modules/imc/store/reducers';
import BankDetailsReducer from '../modules/bankdetails/SuperAdmin/store/reducers/index';
import loginSuccessReducer from '../modules/users/login/store/reducers/index';
import serviceCheckListReducer1 from '../modules/services/store/reducers/index';
import GenInfoReducer from '../modules/checkListGenerator/store/reducers/index';
import DraftReducer from '../modules/draftDocument/store/reducers/index';

// Combine all the sub reducers
const rootReducerCombine = combineReducers({
    myCounter: counterReducer,
    users: superAdminReducer,
    userreducer: userReducer,
    payments: paymentsReducer,
    createimc: IMCReducer,
    bankdetailsreducer: BankDetailsReducer,
    loginsuccessreducer: loginSuccessReducer,
    serviceCheckListReducer: serviceCheckListReducer1,
    geninforeducer: GenInfoReducer,
    draftreducer: DraftReducer
});

export default rootReducerCombine;
